import { useContext } from 'react'
import { FiAlertCircle } from 'react-icons/fi'
import { ButtonSubmit } from '../../../../GlobalStyle'
import Base from '../index'
import { ContentModalPop, FlexButtonDiv } from './style'

import { ModalTotalContext } from '../../../../context/ModalContext'

const PopUp = ({ callBack }) => {
  const { setOpenModal } = useContext(ModalTotalContext)

  return (
    <Base width={'400px'} height={'200px'} noClose>
      <ContentModalPop>
        <FiAlertCircle />
        <p>Adicionar o produto como componente?</p>
        <FlexButtonDiv>
          <ButtonSubmit
            onClick={() => setOpenModal(null)}
            type="button"
            background="red"
            width={'100%'}
          >
            Não
          </ButtonSubmit>
          <ButtonSubmit onClick={() => callBack()} type="button" width={'100%'}>
            Sim
          </ButtonSubmit>
        </FlexButtonDiv>
      </ContentModalPop>
    </Base>
  )
}
export default PopUp
